import { AxiosError } from "axios";
import { apiClient } from "@/shared/api/client";
import { GetCommonCodeListResponseDto } from "@/shared/types/commonCode.types";
import {
    CommonCodeApiResponse,
    GetCommonCodeGroupListResponseDto
} from "../types/commonCode.types";

export const commonCodeApi = {
    getCommonCode: async (grpCode?: string): Promise<CommonCodeApiResponse> => {
        const url = grpCode
            ? `/api/v1/portal/system/common-code?grpCode=${grpCode}`
            : '/api/v1/portal/system/common-code';
        const response = await apiClient.get<CommonCodeApiResponse>(url);
        return response.data;
    },

    getCommonCodeGroupList: async (): Promise<GetCommonCodeGroupListResponseDto> => {
        const response = await apiClient.get<GetCommonCodeGroupListResponseDto>(
            '/api/v1/common-code/group/list'
        );
        return response.data;
    },

    getCommonCodeList: async (grpCode: string): Promise<GetCommonCodeListResponseDto> => {
        const response = await apiClient.get<GetCommonCodeListResponseDto>(
            '/api/v1/common-code/list',
            { params: { grpCode } }
        );
        return response.data;
    },

    saveCommonCodeGroup: async (data: {
        userId: string;
        grpCode: string;
        grpName: string;
        grpVal?: string;
        seqNo?: number;
    }): Promise<{ success: boolean; message?: string; hasChanges?: boolean }> => {
        try {
            const response = await apiClient.post(
                '/api/v1/portal/system/common-code/group',
                data
            );
            return {
                success: true,
                message: response.data?.message || '그룹코드가 저장되었습니다.',
                hasChanges: response.data?.hasChanges !== false,
            };
        } catch (error: unknown) {
            let errorMessage = '그룹코드 저장에 실패했습니다.';
            if (error instanceof Error) errorMessage = error.message;
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error as AxiosError<{ message?: string }>;
                if (axiosError.response?.data?.message) errorMessage = axiosError.response.data.message;
            }
            return { success: false, message: errorMessage };
        }
    },

    saveCommonCode: async (data: {
        userId: string;
        grpCode: string;
        comCode: string;
        comCdName: string;
        comSeqno?: string;
        seqNo?: number;
        useYn: string;
        val1?: string;
        val2?: string;
        val3?: string;
        val4?: string;
        val5?: string;
    }): Promise<{ success: boolean; message?: string; hasChanges?: boolean }> => {
        try {
            const response = await apiClient.post(
                '/api/v1/portal/system/common-code/code',
                data
            );
            return {
                success: true,
                message: response.data?.message || '공통코드가 저장되었습니다.',
                hasChanges: response.data?.hasChanges !== false,
            };
        } catch (error: unknown) {
            let errorMessage = '공통코드 저장에 실패했습니다.';
            if (error instanceof Error) errorMessage = error.message;
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error as AxiosError<{ message?: string }>;
                if (axiosError.response?.data?.message) errorMessage = axiosError.response.data.message;
            }
            return { success: false, message: errorMessage };
        }
    },
};
